import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const speakers = {
    state: () => ({
        items: [],
        filter: {
            searchTerm: null,
            skip: 0,
            take: 20,
            total: 0,
            page: 1,
            hasPayment: true,
            paymentStatus: null,
            paymentType: null,
            packetIDs: [],
            paymentID: null,
            couponCode: null,
            tagIDs: [],
        },
        selectedItems: [],
        loading: true,
    }),
    mutations: {
        setPayments(state, payload) {
            state.items = payload.items;
            state.filter.total = payload.totalCount;
        },
        setSelectedPayments(state, payload) {
            state.selectedItems = payload;
        },
        setPaymentPage(state, payload) {
            state.filter.page = payload;
            this.dispatch("getPayments");
        },
        setPaymentTake(state, payload) {
            state.filter.page = 1;
            state.filter.take = payload;
            this.dispatch("getPayments");
        },
    },
    actions: {
        async getPayments(store) {
            store.state.loading = true;
            await axios
                .post("participant/list", {
                    ...store.state.filter,
                    skip: (store.state.filter.page - 1) * store.state.filter.take,
                })
                .then((res) => {
                    store.state.loading = false;
                    return store.commit("setPayments", res.data.data);
                });
        },
        async toggleSpeaker(store, payload) {
            var res = await axios.post("speaker/toggleisactive", {
                id: store.state.items[payload.index].id,
            });
            return res.data;
        },
        async deleteSpeaker(store, payload) {
            await axios
                .post("speaker/delete", {
                    id: store.state.items[payload.index].id,
                })
                .then((res) => {
                    if (res.data.alert.hasError) {
                        payload.context.$message.error(res.data.alert.message);
                    } else {
                        store.state.items.splice(payload.index, 1);
                        payload.context.$message.success(res.data.alert.message);
                        if (store.state.items.length == 0 && store.state.filter.page != 1) {
                            this.commit("setSpeakerPage", store.state.filter.page - 1);
                        }
                        store.state.filter.total = store.state.filter.total - 1;
                    }
                });
        },
        async changePaymentStatus(store, payload) {
            axios
                .post("participant/changepaymentstatus", {
                    id: payload.item.id,
                    paymentID: payload.item.paymentID,
                    status: payload.status,
                })
                .then((res) => {
                    if (res.data.alert.hasError) {
                        payload.context.$message.error(res.data.alert.message);
                    } else {
                        payload.context.$message.success(res.data.alert.message);
                        store.state.items[payload.index].paymentInfos[
                            payload.paymentIndex
                        ].paymentStatus = payload.status;
                    }
                });
        },
    },
    getters: {},
};
export default speakers;


// WEBPACK FOOTER //
// ./src/store/payments.js